import { render, staticRenderFns } from "./MagnusEffectViz.vue?vue&type=template&id=0da918b2&scoped=true"
import script from "./MagnusEffectViz.vue?vue&type=script&lang=js"
export * from "./MagnusEffectViz.vue?vue&type=script&lang=js"
import style0 from "./MagnusEffectViz.vue?vue&type=style&index=0&id=0da918b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da918b2",
  null
  
)

export default component.exports